<template>
  <Teleport to="body">
    <Transition name="app-update">
      <div v-if="appVersionStore.visible" class="app-update-banner" role="status">
        <div class="app-update-banner__header">
          <p class="app-update-banner__title">新版本已更新，快来试试吧~</p>
          <button
            class="app-update-banner__close"
            type="button"
            aria-label="关闭"
            @click="appVersionStore.dismiss"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.6" />
              <path
                d="M9 9l6 6M15 9l-6 6"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <button
          class="app-update-banner__action"
          type="button"
          :disabled="appVersionStore.applying"
          @click="appVersionStore.applyUpdate"
        >
          立即更新
        </button>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useAppVersionStore } from '@/stores/appVersion'

const appVersionStore = useAppVersionStore()
</script>

<style lang="scss" scoped>
.app-update-banner {
  position: fixed;
  right: 33px;
  bottom: 52px;
  z-index: 5000;
  width: 420px;
  padding: 24px 28px 22px;
  border-radius: 20px;
  background: #5c348f;
  box-shadow: 0 12px 32px rgba(49, 20, 90, 0.45);
  box-sizing: border-box;
}

.app-update-banner__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.app-update-banner__title {
  margin: 0;
  padding-top: 2px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.02em;
}

.app-update-banner__close {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  margin-top: 2px;
  padding: 0;
  border: none;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
    display: block;
  }

  &:hover {
    opacity: 0.85;
  }
}

.app-update-banner__action {
  margin-top: 18px;
  height: 44px;
  min-width: 168px;
  padding: 0 28px;
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 44px;
  cursor: pointer;
  background: linear-gradient(90deg, #f3e7ff 0%, #d9b8ff 42%, #c9a6f8 100%);
  box-shadow: inset 0 0 12px rgba(255, 255, 255, 0.35);
  transition: opacity 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.92;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.8;
  }
}

.app-update-enter-active,
.app-update-leave-active {
  transition:
    opacity 0.22s ease,
    transform 0.22s ease;
}

.app-update-enter-from,
.app-update-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
